import { render, staticRenderFns } from "./ClipperModal.vue?vue&type=template&id=27871149&scoped=true&"
import script from "./ClipperModal.vue?vue&type=script&lang=js&"
export * from "./ClipperModal.vue?vue&type=script&lang=js&"
import style0 from "./ClipperModal.vue?vue&type=style&index=0&id=27871149&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27871149",
  null
  
)

export default component.exports